import i18 from 'i18next';
import { PAGES } from '../pages';

export const individualAccountMenu = [
  {
    title: i18.t('createAccount'),
    checked: true,
  },
  {
    title: i18.t('secureAccount'),
    path: PAGES.SECURE_ACCOUNT,
    nextPath: PAGES.SECURE_NAME,
    previousPath: PAGES.BASE,
    items: [
      {
        title: i18.t('name'),
        previousPath: PAGES.SECURE_ACCOUNT,
        path: PAGES.SECURE_NAME,
        nextPath: PAGES.SECURE_PHONE_NUMBER,
      },
      {
        title: i18.t('phoneNumber'),
        path: PAGES.SECURE_PHONE_NUMBER,
        previousPath: PAGES.SECURE_NAME,
        preSkipPath: PAGES.SECURE_NAME,
        nextPath: PAGES.SECURE_DOB,
      },
      {
        title: i18.t('dob'),
        previousPath: PAGES.SECURE_PHONE_NUMBER,
        path: PAGES.SECURE_DOB,
        nextPath: PAGES.SECURE_IDENTITY,
      },
      {
        title: i18.t('identityVerification'),
        path: PAGES.SECURE_IDENTITY,
        previousPath: PAGES.SECURE_DOB,
        nextPath: PAGES.SECURE_IDENTITY_SSN,
        skipPath: PAGES.ADDRESS,
        items: [
          {
            previousPath: PAGES.SECURE_IDENTITY,
            path: PAGES.SECURE_IDENTITY_SSN,
            nextPath: PAGES.ADDRESS,
          },
        ],
      },
    ],
  },
  {
    title: i18.t('address'),
    path: PAGES.ADDRESS,
    nextPath: PAGES.ADDRESS_ENTER,
    previousPath: PAGES.SECURE_IDENTITY,
    preSkipPath: PAGES.SECURE_IDENTITY,
    items: [
      {
        path: PAGES.ADDRESS_ENTER,
        nextPath: PAGES.ADDRESS_DONE,
        previousPath: PAGES.ADDRESS,
      },
      {
        path: PAGES.ADDRESS_DONE,
        nextPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        previousPath: PAGES.ADDRESS_ENTER,
      },
    ],
  },
  {
    title: i18.t('fund'),
    path: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
    previousPath: PAGES.ADDRESS_DONE,
    skipPath: PAGES.REVIEW,
    items: [
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.PLAID,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.WIRE,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CHECK,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CRYPTOCURRENCY,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
    ],
  },
  {
    title: i18.t('review'),
    path: PAGES.REVIEW,
    nextPath: PAGES.AGREEMENT,
    previousPath: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT,
    preSkipPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
    items: [
      {
        path: PAGES.AGREEMENT,
        nextPath: '/',
        previousPath: PAGES.REVIEW,
      },
    ],
  },
];
